import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/affiliates/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/affiliates', data)
  },
  get(id) {
    return http.get(`/api/v1/affiliates/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/affiliates/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/affiliates/${id}/status`, null, {
      params: { status },
    });
  },
  getPriceTypes(id) {
    return http.get(`/api/v1/affiliates/${id}/price-types`)
  },
  setPriceTypes(id, items) {
    return http.put(`/api/v1/affiliates/${id}/price-types`, { items })
  },
  getPrices(affiliateId, priceTypeId) {
    return http.get(`/api/v1/affiliates/${affiliateId}/price-types/${priceTypeId}/prices`)
  },
  setPrices(affiliateId, priceTypeId, prices) {
    return http.put(`/api/v1/affiliates/${affiliateId}/price-types/${priceTypeId}/prices`, { prices })
  }
}
